import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

import styles from './Button.module.styl'

const Button = (props) => {
  const classes = [
    styles.button,
    styles[props.size],
    styles[props.color],
    props.text ? styles.text : null,
    props.inline ? styles.inline : null,
    props.disabled ? styles.disabled : null,
    props.loading ? styles.loading : null
  ].join(' ')

  if (props.render) {
    switch (props.type) {
      case 'anchor':
        return (
          <a
            className={classes}
            href={props.to}
            onClick={props.onClick}
            rel={props.target === '_blank' ? 'nofollow noopener' : null}
            target={props.target}
          >
            {props.loading && <div className={styles.loader} />}
            {props.children}
          </a>
        )

      case 'link':
        return (
          <Link
            className={classes}
            onClick={props.onClick}
            to={props.to}
          >
            {props.loading && <div className={styles.loader} />}
            {props.children}
          </Link>
        )

      default:
        return (
          <button
            className={classes}
            data-role={props['data-role']}
            disabled={props.disabled}
            onClick={props.onClick}
            type={props.type}
          >
            {props.loading && <div className={styles.loader} />}
            {props.children}
          </button>
        )
    }
  }

  return null
}

Button.propTypes = {
  color: PropTypes.string,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  render: PropTypes.bool,
  role: PropTypes.string,
  size: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.bool,
  to: PropTypes.string,
  type: PropTypes.string,
}

Button.defaultProps = {
  color: 'default',
  disabled: false,
  loading: false,
  render: true,
  to: '/',
  type: 'button'
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js